export default __webpack_public_path__ + "af8c9aa1953b810268f27fbae1f96dd4.png";